import {Component} from "@angular/core";

@Component({
    selector: "otcx-home-market-reports",
    templateUrl: "./home-market-reports.component.html"
})
export class HomeMarketReportsComponent {
}
